import { Map } from "immutable"
import { ReactComponent as IconSpinner } from "icons/lib/spinner.svg"
import {
    AIModelAssignment,
    AIModelAssignmentEnum
} from "../../../../../../../../Models/API/AIModel"
import { TableColumn } from "resha"
import { AIModelActivenessCheckbox } from "./AIModelActivenessCheckbox"

export interface ColumnsProps {
    isModelOnline: boolean
    processingAssignments: Map<AIModelAssignmentEnum, true>
    onChangeActiveness?: (
        assigned: AIModelAssignmentEnum,
        active: boolean,
        useLatestAi: boolean
    ) => void
}

export const aiModelUsageColumns: (
    vals: ColumnsProps
) => TableColumn<AIModelAssignment>[] = ({
    isModelOnline,
    processingAssignments,
    onChangeActiveness
}) => {
    const cols: TableColumn<AIModelAssignment>[] = [
        {
            renderHeader: () => "Used for",
            headerClassName: " font-bold ",
            render: ({ assigned, active, threshold, use_latest_ai }) => {
                const isProcessing = processingAssignments.has(assigned)
                return (
                    <div className="flex items-center">
                        <AIModelActivenessCheckbox
                            isProcessing={isProcessing}
                            isActive={isModelOnline && active}
                            onClick={
                                onChangeActiveness === undefined ||
                                !isModelOnline
                                    ? undefined
                                    : () =>
                                          onChangeActiveness(
                                              assigned,
                                              !active,
                                              !!use_latest_ai
                                          )
                            }
                        />
                        {assigned === "ACTIVE_LEARNING"
                            ? `Active learning (threshold: ${threshold})`
                            : assigned === "TASK"
                            ? "Task"
                            : "Pre-processing"}
                        {isProcessing ? (
                            <IconSpinner className="ml-1 w-h h-4" />
                        ) : null}
                    </div>
                )
            },
            className: "w-1/2"
        },
        {
            renderHeader: () => "Subscribed to latest version",
            headerClassName: " font-bold ",
            render: ({ assigned, active, use_latest_ai }) => {
                const isProcessing = processingAssignments.has(assigned)

                return (
                    <div className="flex items-center">
                        <AIModelActivenessCheckbox
                            isProcessing={
                                (processingAssignments?.has(assigned) ??
                                    false) ||
                                !active
                            }
                            isActive={isModelOnline && !!use_latest_ai}
                            activeText="Unsubscribe latest version"
                            inactiveText="Subscribe to latest version"
                            onClick={
                                onChangeActiveness === undefined ||
                                !isModelOnline
                                    ? undefined
                                    : () =>
                                          onChangeActiveness(
                                              assigned,
                                              !!active,
                                              !use_latest_ai
                                          )
                            }
                            className="ml-2"
                        />
                        {isProcessing ? (
                            <IconSpinner className="ml-1 w-h h-4" />
                        ) : null}
                    </div>
                )
            },
            className: "w-1/2"
        }
    ]
    return cols
}
